import { ExternalMapLayerState, ExternalMapLayer, ExternalMapLayerType } from "./types";

export function getDefaultState(): ExternalMapLayerState {
	return {
		externalMapLayers: [] as ExternalMapLayer[],
		externalMapLayerTypes: [] as ExternalMapLayerType[]
	};
}
